import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Box,
  Button,
  Typography,
  TextField,
  Select,
  MenuItem,
  Grid,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { EmojiEvents, Save } from "@material-ui/icons";

import { gradeNationalLevel } from "../../../../reducer/studentResearch/action";
import { NATIONAL_LEVEL_RESULT_OPTIONS, CONFERENCE_RESULT_PARTICIPATE } from "../../../../constants/projectStatus";
import SectionCard from "../../utils/SectionCard";
import LevelNoteField from "../../utils/LevelNoteField";

// NationalLevelForm — Phòng QLKH cập nhật kết quả cấp Quốc gia. Chỉ hiển thị
// khi đã đề xuất lên cấp Bộ/Quốc gia ở bước cấp Trường (national_level_pending).
export default function NationalLevelForm({ detail, onDone }) {
  const dispatch = useDispatch();
  const [prize, setPrize] = useState(detail?.nationalLevelPrize || CONFERENCE_RESULT_PARTICIPATE);
  const [comment, setComment] = useState(detail?.nationalLevelComment || "");
  const [note, setNote] = useState(detail?.nationalLevelNote || "");
  const [proposeNext, setProposeNext] = useState(!!detail?.nationalLevelEligible);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setPrize(detail?.nationalLevelPrize || CONFERENCE_RESULT_PARTICIPATE);
    setComment(detail?.nationalLevelComment || "");
    setNote(detail?.nationalLevelNote || "");
    setProposeNext(!!detail?.nationalLevelEligible);
  }, [detail?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSave = async () => {
    setSaving(true);
    try {
      const ok = await dispatch(gradeNationalLevel(detail.id, { prize, comment, note, proposeNext }));
      if (ok && onDone) onDone();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box padding="16px 24px">
      <SectionCard icon={<EmojiEvents />} title="Cập nhật kết quả cấp Quốc gia" marginTop={0}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={6}>
            <Typography variant="body2" style={{ marginBottom: 6 }}>
              Xếp loại <span style={{ color: "#c62828" }}>*</span>
            </Typography>
            <Select
              fullWidth
              variant="outlined"
              margin="dense"
              value={prize}
              onChange={(e) => setPrize(e.target.value)}
            >
              {NATIONAL_LEVEL_RESULT_OPTIONS.map((o) => (
                <MenuItem key={o.value} value={o.value}>
                  {o.label}
                </MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={proposeNext}
                  onChange={(e) => setProposeNext(e.target.checked)}
                />
              }
              label="Đề xuất báo cáo tại Hội nghị SVNCKH cấp quốc tế"
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" style={{ marginBottom: 6 }}>
              Nhận xét
            </Typography>
            <TextField
              fullWidth
              multiline
              minRows={3}
              variant="outlined"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
          </Grid>
          <LevelNoteField value={note} onChange={setNote} />
        </Grid>
      </SectionCard>

      <Box
        marginTop={3}
        paddingTop={2}
        display="flex"
        justifyContent="flex-end"
        borderTop="solid 1px #e0e0e0"
      >
        <Button
          variant="contained"
          color="primary"
          disabled={saving}
          onClick={handleSave}
          startIcon={<Save />}
        >
          Lưu kết quả cấp Quốc gia
        </Button>
      </Box>
    </Box>
  );
}
